export const Settings = {
	CONTINUE_ON_ENGINE_ERROR: true,
};
